import {JSONAttrs, JSONContent} from '../types';
import {getTextAlign} from '../utils';
import {useBuildContent} from 'hooks/guidebooks/useBuildContent';
import {StyledHeading} from '../styled';

type Props = {
  level?: number;
  content: JSONContent[];
  attrs?: JSONAttrs;
};

function Heading({level = 1, content, attrs}: Props) {
  const buildedContent = useBuildContent(content);

  return (
    <StyledHeading $level={level} style={{textAlign: getTextAlign(attrs)}}>
      {buildedContent}
    </StyledHeading>
  );
}

export {Heading};
